export function mountVueApp ({
  target,
  mount,
  mountEvents = ['turbo:load', 'turbo:render'],
  unmountEvents = ['turbo:before-render', 'turbo:before-cache'],
}) {
  let app = null
  let mountTarget = null

  function storeMountTarget () {
    const targetElement = document.querySelector(target)
    mountTarget = mountTarget || (targetElement && targetElement.cloneNode(false))
  }

  function mountApp (event) {
    if (document.querySelector(target) && !app) {
      storeMountTarget()
      app = mount(event)
    }
  }

  function unmountApp () {
    if (app) {
      const appElement = app.$el
      app.$destroy()
      app = null

      if (mountTarget && appElement && appElement.parentNode && !document.querySelector(target)) {
        appElement.parentNode.replaceChild(mountTarget.cloneNode(false), appElement)
      }
    }
  }

  mountEvents.forEach((eventName) => document.addEventListener(eventName, mountApp))
  unmountEvents.forEach((eventName) => document.addEventListener(eventName, unmountApp))

  mountApp()

  return { mountApp, unmountApp }
}
